export const PortalLang = {
    enter: 'ورود',
    createForm: 'ساخت فرم جدید',
    premium: 'جهت عدم نمایش تبلیغات حساب خود را به نسخه بالاتر ارتقا دهید',
    createDesc: '!برای ساخت رایگان فرم، کلیک کنید',
    logout: 'خروج',
    kioskLogout: 'کد اتصال خود را جهت خروج از حساب کاربری وارد کنید',
    wrongCodeErr: 'کد وارد شده با کد اتصال این انتشار مغایر است. لطفا کد دیگری وارد کنید',
};
